<template>
    <v-sheet outlined rounded >
        <v-toolbar dense flat color="secondary"> 
            <v-toolbar-title>{{$t("malfaction_report_by_truck_plant")}}</v-toolbar-title>
                   

            <v-row no-gutters>
                    <v-spacer></v-spacer>
                    <v-col cols="6" md="4" no-gutters>
                        <TruckByPlateNumber
                            class="me-1"
                            @change="handelChange"
                            @enter="handelEnter"
                            outlined
                            dense
                            hide-details
                            background-color='white'
                        />
                    </v-col>
                    <v-col cols="6" md="2" no-gutters>
                        <v-btn color="primary" @click="handelClick" :disabled="loading">
                             {{$t("SEARCH")}} 
                        </v-btn>
                    </v-col> 
            </v-row>
        </v-toolbar>
        <v-row>
            <v-col cols="6"> 
               <MalfactionsReportByTruckPlateNumberTableTruckDetails :data="truchDetials" :loading="loading"/>
                <v-divider></v-divider>
            </v-col>
            <v-col cols="3">
            </v-col>
        </v-row>
        <v-row>
            <v-col>
            <v-progress-linear
                    v-if="loading"
                    indeterminate
                    color="yellow darken-2"
            ></v-progress-linear>

            <MalfactionsReportByTruckPlateNumberTruckJobsTable :data="truckJobs" :loading="loading" @openJobCard="handelOpenJobCard"/>
            </v-col>
        </v-row>
        <JobCard v-if="showCard"/>
        <JobcardDisplayDialog ref="jobcardDisplayDialog"/>
    </v-sheet>
</template>

<script>
import JobcardDisplayDialog from './JobcardDisplayDialog.vue'
import JobCard from '../views/JobCard.vue'
import MalfactionsReportByTruckPlateNumberTruckJobsTable from './MalfactionsReportByTruckPlateNumberTruckJobsTable'
import  TruckByPlateNumber  from "./TruckByPlateNumber.vue";
import MalfactionsReportByTruckPlateNumberTableTruckDetails from "./MalfactionsReportByTruckPlateNumberTableTruckDetails.vue";
import {getTruckByid} from './../services/reports'
export default {
    components:{
        TruckByPlateNumber,
        MalfactionsReportByTruckPlateNumberTableTruckDetails,
        MalfactionsReportByTruckPlateNumberTruckJobsTable,
        JobCard,
        JobcardDisplayDialog
        },
        data() {
            return {
                truchDetials : {
                    truckType:'',
                    plateNumber:'',
                    driverName:''
                },
                truckJobs : null,
                loading : false,
                plateId : null,
                showCard : false
            }
        },
        methods:{
            async handelChange(e) {
                this.plateId = e
            },
            handelEnter(e) {
                    this.resetRecords()
                    this.fetchData(e)
            },
            handelClick() {
                this.resetRecords()
                if(this.plateId !== null ){
                    this.fetchData(this.plateId)
                }
            },
            async fetchData(plate) {
                this.loading = true
                let response = await getTruckByid(plate)
                this.truckJobs = response.data
                this.truchDetials.truckType = response.data[0].truck_type
                this.truchDetials.plateNumber = response.data[0].plate_number
                this.truchDetials.driverName = response.data[0].driver_name
                this.loading = false
                this.plateId = null
            },
            resetRecords() {
                this.truckJobs = ''
                this.truchDetials = {
                    truckType:'',
                    plateNumber:'',
                    driverName:''
                }
            },
            handelOpenJobCard(e) {
                this.$refs.jobcardDisplayDialog.open({ id:e })
                // this.showCard = true
                //console.log(e)
            }
        }
}
</script>

<style>

</style>